import * as Utils from 'atg/utils/Utils';
import StickyTemplate from 'atg/vendor/StickyTemplate/1.0/StickyTemplate';

const $ = window.$;

let $overlay;
const $parent = $('#app');
const activeDialogs = [];
const fadeDuration = 200;

const addDialog = dialog => {
  if (!$overlay) {
    $overlay = $('<div class="overlay grey dialog-overlay"/>');
    $parent.append($overlay);
  }
  activeDialogs.push(dialog);
  $parent.append(dialog.$container);

  if (activeDialogs.length === 1) {
    document.addEventListener('click', onDocClick, true);
  }
};

const removeDialog = dialog => {
  for (let i = activeDialogs.length; i >= 0; i--) {
    if (activeDialogs[i] === dialog) {
      activeDialogs.splice(i, 1);
      break;
    }
  }

  if (activeDialogs.length === 0) {
    document.removeEventListener('click', onDocClick, true);
    if ($overlay) {
      $overlay.fadeOut(fadeDuration, () => {
        $overlay.unevent('click');
        $overlay.remove();
        $overlay = null;
      });
    }
  }
};

const onDocClick = e => {
  if (activeDialogs.length > 0) {
    const target = e.target;
    const $wrapper = activeDialogs[activeDialogs.length - 1].$container;
    const wrapper = $wrapper.get(0);
    const dialog = $wrapper.find('.dialog').get(0);

    if (
      (target === wrapper || wrapper.contains(target)) &&
      target !== dialog &&
      !dialog.contains(target)
    ) {
      e.stopPropagation();
      Dialog.closeCurrent(true);
    }
  }
};

class Dialog {
  static closeCurrent = () => {
    if (activeDialogs.length > 0) {
      activeDialogs[activeDialogs.length - 1].close(true);
    }
  };

  static closeAll = immediate => {
    if (activeDialogs.length > 0) {
      activeDialogs.forEach(dialog => dialog.close(true, immediate));
    }
  };

  constructor(templateName, templateProperties, delegate = null) {
    this.delegate = delegate;
    this.$container = StickyTemplate.jq(templateName, templateProperties);
    this.close = this.close.bind(this);
    this.onShow = this.onShow.bind(this);

    addDialog(this);

    // Wait a frame to allow sub classes to initialize
    setTimeout(() => {
      this._show();
    }, 0);
  }

  _show() {
    const $d = this.$container.find('.dialog');
    const oh = $d.outerHeight() - $(window).height();
    if (oh > 0) {
      $d.css({
        'margin-top': oh,
      });
      this.$container.addClass('overflow-vertical');
    }
    this.$container.find('.dialog').fadeIn(fadeDuration, this.onShow);
  }

  onShow() {}

  close(isClickOutside, immediate) {
    removeDialog(this);
    this.$container.fadeOut(immediate ? 0 : fadeDuration, () => {
      isClickOutside &&
        this.willCloseFromOutside &&
        this.willCloseFromOutside();
      this.$container.remove();
    });
  }

  getAPI() {
    return Utils.callDelegate(this.delegate, 'getDialogAPI');
  }
}

export default Dialog;
